// /src/store/reducers/settingsReducer.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ipList: [], // Array of whitelisted IPs (max 10)
  senderNumbers: [], // List of available sender numbers
  selectedSenderNumber: "", // Currently selected sender number
  callbackUrl: "", // Callback URL set by the user
  callbackServerIp: "", // Read-only IP address of the callback server
  apiKeys: [], // Array of API key objects (each with id and key)
  clientId: "",
  callbackApiKey: ""
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetSettings(state, action) {
      state.ipList = initialState.ipList;
      state.senderNumbers = initialState.senderNumbers;
      state.selectedSenderNumber = initialState.selectedSenderNumber;
      state.callbackUrl = initialState.callbackUrl;
      state.clientId = initialState.clientId;
      state.callbackServerIp = initialState.callbackServerIp;
      state.apiKeys = initialState.apiKeys;
      state.callbackApiKey = initialState.callbackApiKey;
    },
    // IP Whitelist Actions
    setIpList(state, action) {
      state.ipList = action.payload;
    },
    addIp(state, action) {
      if (state.ipList.length < 10) {
        state.ipList.push(action.payload);
      }
    },
    removeIp(state, action) {
      state.ipList = state.ipList.filter((ip) => ip !== action.payload);
    },
    setClientId(state, action) {
      state.clientId = action.payload;
    },
    // SMS Sender Number Actions
    setSenderNumbers(state, action) {
      state.senderNumbers = action.payload;
    },
    addSenderNumber(state, action) {
      state.senderNumbers.push(action.payload);
    },
    setSelectedSenderNumber(state, action) {
      state.selectedSenderNumber = action.payload;
    },
    // Callback URL Actions
    setCallbackUrl(state, action) {
      state.callbackUrl = action.payload;
    },
    setCallbackServerIp(state, action) {
      state.callbackServerIp = action.payload;
    },
    setCallbackApiKey(state, action) {
      state.callbackApiKey = action.payload;
    },
    // API Key Actions
    setApiKeys(state, action) {
      state.apiKeys = action.payload;
    },
    addApiKey(state, action) {
      if (state.apiKeys.length < 3) {
        state.apiKeys.push(action.payload);
      }
    },
    removeApiKey(state, action) {
      state.apiKeys = state.apiKeys.filter(
        (keyObj) => keyObj.id !== action.payload
      );
    },
  },
});

export const {
  setIpList,
  addIp,
  removeIp,
  setSenderNumbers,
  addSenderNumber,
  setSelectedSenderNumber,
  setCallbackUrl,
  setCallbackServerIp,
  setCallbackApiKey,
  setApiKeys,
  addApiKey,
  removeApiKey,
  setClientId,
  resetSettings
} = settingsSlice.actions;

export default settingsSlice.reducer;
